import React from "react"
import {
  Container,
  Title,
  ContentArea,
  HeadShotArea,
  ProjectArea,
  ContextArea,
  EnPTitle,
  EnPName,
  Context,
  ReadMore,
} from "./about.style"
import { className } from "./about.className"
import Img from "../gatsbyImage/gatsbyImage"
import { profile } from "../../providers/profile/profile.data"

const About = ({ to = ``, title = ``, hasReadMore = false }) => {
  const { headShot, autobiography, experience, project } = profile
  return (
    <Container to={to} title={title}>
      <ContentArea>
        <HeadShotArea>
          <Img
            filename={headShot.url}
            alt={headShot.alt}
            style={{ width: `100%`, borderRadius: `50%`, margin: `auto` }}
          />
        </HeadShotArea>
        <ContextArea>
          <Context>{autobiography}</Context>
        </ContextArea>
        <ProjectArea>
          <EnPTitle className={className.EnPTitle}>經歷</EnPTitle>
          {experience.map(({ id, name, company }) => (
            <ul key={id}>
              <EnPName className={className.EnPName}>
                {name} - {company}
              </EnPName>
            </ul>
          ))}
          <EnPTitle className={className.EnPTitle}>作品</EnPTitle>
          {project.map(({ id, name }) => (
            <ul key={id}>
              <EnPName className={className.EnPName}>{name}</EnPName>
            </ul>
          ))}
        </ProjectArea>
      </ContentArea>
      {hasReadMore && (
        <ReadMore className={className.readMore}>READ MORE</ReadMore>
      )}
    </Container>
  )
}

export default About
